import React from "react";
import {
  fmtDate,
  Table,
} from "./shared";

export function AttendTab({ items }) {
  const rows = items.map((it) => [
    fmtDate(it.created_at),
    <strong key="n">{it.full_name}</strong>,
    <>
      <a className="text-[#875F45] underline" href={`mailto:${it.email}`}>
        {it.email}
      </a>
      {it.phone && (
        <div className="text-xs text-[#899480]">{it.phone}</div>
      )}
    </>,
    <span className="inline-flex px-2.5 py-1 rounded-full bg-[#3F5043] text-[#F8F7F3] text-[10px] uppercase tracking-wider">
      {it.support_type.replace("_", " ")}
    </span>,
    it.language || "—",
    <>
      <div>{it.clinic_name || "—"}</div>
      {it.appointment_date && (
        <div className="text-xs text-[#899480]">{it.appointment_date}</div>
      )}
    </>,
    it.notes || "—",
  ]);
  return (
    <Table
      testid="admin-table-attend"
      headers={["Date", "Name", "Contact", "Support", "Language", "Clinic / Appt", "Notes"]}
      rows={rows}
    />
  );
}

export function ConsultationsTab({ items }) {
  const rows = items.map((it) => [
    fmtDate(it.created_at),
    <strong key="n">{it.full_name}</strong>,
    <a className="text-[#875F45] underline" href={`mailto:${it.email}`}>
      {it.email}
    </a>,
    it.phone || "—",
    it.service || "—",
    it.preferred_format || "—",
    it.message || "—",
  ]);
  return (
    <Table
      testid="admin-table-consultations"
      headers={["Date", "Name", "Email", "Phone", "Service", "Format", "Message"]}
      rows={rows}
    />
  );
}

export function ChatLeadsTab({ items }) {
  const rows = items.map((it) => [
    fmtDate(it.created_at),
    <strong key="n">{it.full_name}</strong>,
    <a className="text-[#875F45] underline" href={`mailto:${it.email}`}>
      {it.email}
    </a>,
    it.phone || "—",
    <code className="text-xs text-[#899480]">{it.session_id?.slice(0, 16)}…</code>,
  ]);
  return (
    <Table
      testid="admin-table-chat-leads"
      headers={["Date", "Name", "Email", "Phone", "Session"]}
      rows={rows}
    />
  );
}

export function NewsletterTab({ items }) {
  const rows = items.map((it) => [
    fmtDate(it.created_at),
    <a className="text-[#875F45] underline" href={`mailto:${it.email}`}>
      {it.email}
    </a>,
  ]);
  return (
    <Table
      testid="admin-table-newsletter"
      headers={["Date", "Email"]}
      rows={rows}
    />
  );
}

// ============================================================
// Groups Tab — admin create group, add members, view messages
